// Mirrors trpc.stock waste outputs (apps/web/src/api/trpc/routers/stock.ts).

export const WASTE_REASONS = [
  "spoiled",
  "expired",
  "broken",
  "staff_meal",
  "comp",
  "returned",
  "other",
] as const;

export type WasteReason = (typeof WASTE_REASONS)[number];

export type WasteEntry = {
  id: number;
  stock_item_id: number | null;
  product_id: number | null;
  name: string | null;
  quantity: number;
  unit: string | null;
  reason: WasteReason;
  note: string | null;
  cost_total: number;
  occurred_at: string;
};

/** A product that has a recipe, so it can be wasted as a whole dish. */
export type Dish = { id: number; name: string };
